import { Skeleton } from 'antd';

export const MyTradesSkeleton = () => {
  return (
    <div className="max-w-7xl mx-auto px-0 sm:px-4 py-4 sm:py-8">
      {/* En-tête avec statistiques */}
      <div className="mb-6 px-4 sm:px-0">
        <div className="flex justify-between items-start mb-6">
          <div>
            <Skeleton.Input active size="large" className="!w-[300px] !mb-2" />
            <Skeleton.Input active size="small" className="!w-[200px]" />
          </div>
          <Skeleton.Button active size="large" className="!w-[150px]" />
        </div>

        {/* Cartes de statistiques */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
          {[...Array(4)].map((_, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-3 sm:p-4">
              <Skeleton.Input active size="small" className="!w-[80px] !mb-2" />
              <Skeleton.Input active size="large" className="!w-[60px]" />
            </div>
          ))}
        </div>
      </div>

      {/* Navigation par onglets */}
      <div className="bg-white shadow mb-6 rounded-lg">
        <div className="border-b border-gray-200">
          <div className="flex flex-col sm:flex-row justify-between items-stretch sm:items-center px-4 sm:px-6">
            <nav className="flex w-full">
              {[...Array(3)].map((_, index) => (
                <div key={index} className="flex-1 py-3 sm:py-4 px-3 sm:px-6">
                  <Skeleton.Button active size="large" className="!w-full" />
                </div>
              ))}
            </nav>
          </div>
        </div>
      </div>

      {/* Liste des échanges */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 animate-fadeIn">
        {[...Array(6)].map((_, index) => (
          <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
            {/* En-tête de la carte */}
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2">
                <Skeleton.Avatar active size="small" />
                <Skeleton.Input active size="small" className="!w-[100px]" />
              </div>
              <div className="flex items-center gap-2">
                <Skeleton.Button active size="small" className="!w-[80px]" />
                <Skeleton.Button active size="small" className="!w-[60px]" />
              </div>
            </div>

            {/* Contenu de la carte */}
            <div className="flex items-start gap-4 mb-4">
              <Skeleton.Image active className="!w-[120px] !h-[160px]" />
              <div className="flex-1">
                <Skeleton.Input active size="small" className="!w-full !mb-2" />
                <div className="grid grid-cols-3 gap-2">
                  {[...Array(6)].map((_, i) => (
                    <Skeleton.Image key={i} active className="!w-full !aspect-[3/4]" />
                  ))}
                </div>
              </div>
            </div>

            {/* Boutons d'action */}
            <div className="mt-4 pt-3 border-t border-gray-100">
              <div className="flex gap-2">
                <Skeleton.Button active size="large" className="!w-full" />
                <Skeleton.Button active size="large" className="!w-full" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}; 